import { EventConstants, Parser } from "@quest/platform-murka-phase_2/dist";
// import { PlatformConstantsGame } from "../Constants/PlatformConstantsGame";
import { clone, dispatcher, IEvent, ingenuity, IObject } from "@quest/base-core";
import { gameConstants } from "../Constants/gameConstants";
import { GameParserModel } from "./GameParserModel";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { IParamsData, ILines } from "@quest/oddsworks-platform";
import { SlotConstants } from "@quest/slot-core";
import { EventConstants as PlatformEventConstants } from "@quest/platform-core";
import { SlotEventConstantsBehavior } from "@quest/murka-games-behavior-panther";
export class GameParser extends Parser {
  protected model: GameParserModel;
  protected mysterySymbol: number = gameConstants.MYSTERY_SYMBOL_GAME_ID;

  protected specialSymNum: number[] = [
    gameConstants.SPECIAL_SYMBOL_NOTE,
    gameConstants.SPECIAL_SYMBOL_MAGNIFY,
    gameConstants.SPECIAL_SYMBOL_KEY,
    gameConstants.SPECIAL_SYMBOL_SPOTLIGHT,
    gameConstants.MAN_SYMBOL_1X3,
    gameConstants.MAN_SYMBOL_1X5,
  ];
  protected udpatedSpecialSymNum: number[] = [
    gameConstants.SPECIAL_SYMBOL_NOTE_ID,
    gameConstants.SPECIAL_SYMBOL_MAGNIFY_ID,
    gameConstants.SPECIAL_SYMBOL_KEY_ID,
    gameConstants.SPECIAL_SYMBOL_SPOTLIGHT_ID,
    gameConstants.MAN_SYMBOL_1X3_ID,
    gameConstants.MAN_SYMBOL_1X5_ID,
  ];
  protected mysterySymols: number[] = [gameConstants.MYSTERY_SYMBOL_ID, gameConstants.SPECIAL_MYSTERY_SYMBOL_ID];

  protected bindEvent(): void {
    super.bindEvent();
    dispatcher.on(eventDispatchers.PARSE_NEXT_CASCADE_DATA, this.parseNextCascadeData, this);
    dispatcher.on(eventDispatchers.PARSE_NEXT_MONEY_HUNT_DATA, this.parseMoneyHuntingRewardData, this);
  }

  protected processParameters(params: IParamsData): void {
    
    this.model.setGameTotalWinAmt(0);
    this.model.setMoneyAndClueBasegameWin(0);
    this.resetFeatureData();
    this.model.setGameTotalWinAmt(params.creditsWon);
    let updatedData: any = this.parseCascadeGridInBaseGame(params);
    super.processParameters(updatedData);
    this.model.setBaseGameStops(params.reelStops);
    this.model.setReelGrid(
      this.convertReelGridWithStops(this.model.getReelGrid(), this.model.getBaseGameStops(), this.model.getBaseGameReelSetWithStack())
    );
    this.model.setReelGrid(this.updateMysterySymbolsInGrid(this.model.getReelGrid()));
    this.model.setReelGrid(this.updateReelGridWithStack(this.model.getReelGrid()));
    if (params.bonusInfo) {
      // this.processScatterTriggerInfo(params.bonusInfo);
    }
    this.model.setMoneyAndClueBasegameWin(this.getBaseGameMoneyHuntAmt(params.bonusInfo)) //used when game is broken in freegame  and we need to add feature win in total basegame win
    if (ingenuity.configData.isBrokenGame) {
    
      this.model.setTriggerReelGrid(this.model.getReelGrid());
      this.model.setLastCascadeGridForFg(this.getTriggeringGrid(params));
    }
    this.parseCollectSymbolOffestsData();
  }
  private getBaseGameMoneyHuntAmt(data:any):number{
    let featureWinAmount:number = 0;
    let clueWinAmount:number = 0;
    data.forEach((data: any) => {
      if (data.bonusName === ingenuity.configData.moneyHunting) {
        data.creditsWon && (featureWinAmount = data.creditsWon);
      }
      if (data.bonusName === ingenuity.configData.CollectMeter) {
        data.creditsWon && (clueWinAmount = data.creditsWon);
      }
    })
    return featureWinAmount + clueWinAmount;
  }
  private resetFeatureData(): void {
    this.model.setPreCollectMeterData(undefined);
    this.model.setclueRevealedInfo(undefined);
    this.model.setclueRevealedWinAmt(0)
    this.model.setClueRevealedFeatureStatus(false);
    this.model.setIsGrandJPAvailable(false);
  }
  // This method is use to update mystery(77) & special mystery(78) symbols as per mystery sym response in grid
  // after getting 10X7 grid from reel set
  private updateMysterySymbolsInGrid(grid: number[][]): number[][] {
    grid.forEach((element, col) => {
      if (Array.isArray(element)) {
        element.forEach((position, row) => {
          if (gameConstants.MYSTERY_SYMBOL_GAME_ID === position) {
            element[row] = this.mysterySymbol;
          } else if (gameConstants.SPECIAL_MYSTERY_SYMBOL_GAME_ID === position) {
            this.model.getSpecialMysterySymbolsData().forEach((data: any) => {
              if (data.offset[0] === col && data.offset[1] === row) {
                grid[data.offset[0]][data.offset[1]] = data.symbol;
              }
            }, this);
          }
        });
      }
    }, this);
    return grid;
  }

  /**
   * function will change first cascade grid with actual response reel grid
   */
  private parseCascadeGridInBaseGame(response: any): any {
    this.resetCascadeData(); // reset cascade data
    // new logic for cascade game
    const bonusData = response.bonusInfo.find((data: IObject) => data.bonusName === ingenuity.configData.cascadeBonusName);
    if (bonusData && bonusData.cascadeList.length) {
      const cascade = bonusData.cascadeList[0];
      response.reelLayout = cascade.cascadeGrid;
      response.winningLines = cascade.winningLines;
      response.reelStops = cascade.stops;
      this.model.setTotalCascadeWin(bonusData.creditsWon);
      this.model.setCascadeAccumulatedWin(bonusData.cascadeList[0].winningLines.creditsWon);
    }
    return response;
  }

  /**
   * This method will reset cascade data.
   */
  private resetCascadeData(): void {
    this.model.setCascadingStatus(false);
    this.model.setTotalCascadeWin(0);
    this.model.setCascadeAccumulatedWin(0);
  }

  // Override to parse freespin triggered
  protected parseFreeSpin(response: any): void {
    super.parseFreeSpin(response);
    this.model.setIsFreeSpintriggered(true);
  }

  /**
   * function will parse next cascade data
   * called after every cascade
   */
  private parseNextCascadeData(): void {
    const index: number = this.model.getCascadeResponse().length - this.model.getCascadingCount();
    this.model.setCascadeNumber(index); // setting current cascade index for FS-BAR
    this.model.setTotalCascadeNumber(this.model.getCascadeResponse().length - 1); // setting current cascade index for FS-BAR
    let currentCascade: any = this.model.getCascadeResponse()[index];
    this.model.setCascadeWin(currentCascade.winningLines.creditsWon);
    this.model.setCascadeAccumulatedWin(this.model.getCascadeAccumulatedWin() + currentCascade.winningLines.creditsWon);
    this.model.setTotalWin(this.model.getTotalWin() + currentCascade.winningLines.creditsWon);
    this.model.setCascadeOffsets([this.model.getLinesWinAllUniquePositions()]);
    this.processWinningLines(currentCascade.winningLines);
    this.model.setCurrentCascadingReelNumber(this.getTotalReelBurstOffsets());
    let bigGrid: number[][];
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
      this.model.setBaseGameStops(currentCascade.stops);
      bigGrid = this.convertReelGridWithStops(
        this.updateReelGrid(currentCascade.cascadeGrid),
        this.model.getBaseGameStops(),
        this.model.getBaseGameReelSetWithStack()
      );
    } else {
      this.model.setFreeGameStops(currentCascade.stops);
      bigGrid = this.convertReelGridWithStops(
        this.updateReelGrid(currentCascade.cascadeGrid),
        this.model.getFreeGameStops(),
        this.model.getFreeGameReelSetWithStack()
      );
    }
    this.model.setCurrentCascadingReelNumber(this.getTotalReelBurstOffsets());
    const updatedStackGrid: number[][] = this.updateReelGridWithStack(this.updateMysterySymbolsInGrid(bigGrid));
    this.model.setBaseGameGridForStack(clone(this.model.getReelGrid()));
    this.model.setReelGrid(updatedStackGrid);
    dispatcher.fireEvent(eventDispatchers.ON_CASCADE_REELS);
    this.processCascadeBonusData(currentCascade.bonusInfo); // to parse per cascade bonus infor data.
    if (index === this.model.getCascadeResponse().length - 1) {
      this.parseCollectSymbolOffestsData();
    }
  }

  private parseCollectSymbolOffestsData(): void {
    const specialSymbolData: any = [];
    const HiddenSymbolCount: number = 5;
    const reelGrid: number[][] = this.model.getReelGrid();
    for (let reelId: number = 0; reelId < reelGrid.length; reelId++) {
      for (let symId: number = 5; symId < reelGrid[reelId].length; symId++) {
        const specialSymbol: number = reelGrid[reelId][symId];
        const offsets: number[] = [reelId, symId - HiddenSymbolCount];
        if (gameConstants.SPECIAL_SYMBOLS_CONVERTED.includes(specialSymbol)) {
          specialSymbolData.push({ symbol: specialSymbol, offset: offsets });
        }
      }
    }
    if (specialSymbolData.length) {
      !this.model.getIsSpecialSymbol() && this.model.setIsSpecialSymbol(true);
      this.model.setSpecialSymbolData(specialSymbolData);
    }
  }

  // Override to convert and update reel grid with stack symbols
  private convertAndUpdateReelGridWithStack(): void {
    this.model.setReelGrid(this.convertReelGrid(this.model.getReelGrid()));
    this.model.setReelGrid(this.updateReelGridWithStack(this.model.getReelGrid()));
  }

  /**
   * Convert 5x7 reel grid into 10x7 using reel set
   * only for init
   */
  private convertReelGrid(reelGrid: number[][]): number[][] {
    const reelSetLengthDecrement: number = gameConstants.OFFSET_INCREMENT_X5;
    if (reelGrid) {
      const finalGrid: number[][] = [];
      for (let i: number = 0; i < reelGrid.length; i++) {
        let reelSet: number[] = clone(this.model.getBaseGameReelSetWithStack()[i]);
        let indx: number;
        for (let index: number = 0; index < reelSet.length - reelSetLengthDecrement; index++) {
          if (
            reelSet[index] === reelGrid[i][0] &&
            reelSet[index + 1] === reelGrid[i][1] &&
            reelSet[index + 2] === reelGrid[i][2] &&
            reelSet[index + 3] === reelGrid[i][3] &&
            reelSet[index + 4] === reelGrid[i][4]
          ) {
            indx = index;
            break;
          }
        }
        finalGrid.push(this.storeValueInReelGrid(reelGrid[i], indx, reelSet));
      }
      return finalGrid;
    }
  }

  /**
   * function will add more symbols on reel to make it 10x7 with the help of stops
   */
  private convertReelGridWithStops(grid: number[][], stops: number[], reelSet: number[][]): number[][] {
    let newGrid: number[][] = [];
    stops.forEach((pos: number, index: number) => {
      newGrid[index] = this.storeValueInReelGrid(grid[index], pos, reelSet[index]);
    });
    return newGrid;
  }

  /**
   * Store value in reel grid using reel set
   */
  private storeValueInReelGrid(reelGrid: number[], subsetIndex: number, reelSet: number[]): number[] {
    let reelSetIndex: number = reelSet.length;
    for (let i: number = 0; i < gameConstants.OFFSET_INCREMENT_X5; i++) {
      if (subsetIndex > 0) {
        reelGrid.unshift(reelSet[--subsetIndex]);
      } else {
        reelGrid.unshift(reelSet[--reelSetIndex]);
      }
    }
    return reelGrid;
  }

  // Override to update win lines offset position based on 10X7 grid
  protected processLinesData(data: ILines[]): void {
    super.processLinesData(data);
    this.model.setWinLinesData(this.updateWinLineOffSet(this.model.getWinLinesData()));
    this.model.setCascadeLineToggleCount(this.model.getWinLinesData().length);
    this.checkBoundarySymbols(data);
  }

  // To find bountry symbols
  private checkBoundarySymbols(data: ILines[]): void {
    let linesData: IObject[] = [];
    data.forEach((value: any, index: number) => {
      let lines: IObject[] = [];
      lines.push(value);
      let eachLine: IObject[] = [];
      const uniqueOffsets = [...new Set(lines.flatMap((entry) => entry.matchPositions))].map((pos) => pos - 1);
      uniqueOffsets.forEach((val) => {
        let boundDetails: any = {};
        boundDetails = {
          top: this.getTopBound(uniqueOffsets, val),
          bottom: this.getBottomBound(uniqueOffsets, val),
          left: this.getLeftBound(uniqueOffsets, val),
          right: this.getRightBound(uniqueOffsets, val),
          pos: val,
        };
        eachLine.push(boundDetails);
      });
      linesData[index] = clone(eachLine);
    }, this);
    this.model.setWinSymBounds(linesData);
  }

  // To get symbols as a top symbols for cluster win
  private getTopBound(uniqueOffsets: number[], val: number): boolean {
    if (Math.floor(val / this.model.getNumCols()) == 0) {
      return true;
    } else if (val - this.model.getNumCols() >= 0 && !uniqueOffsets.includes(val - this.model.getNumCols())) {
      return true;
    } else {
      return false;
    }
  }

  // To get symbols as a bottom symbols for cluster win
  private getBottomBound(uniqueOffsets: number[], val: number): boolean {
    if (Math.floor(val / this.model.getNumCols()) == this.model.getNumRows() - 1) {
      return true;
    } else if (!uniqueOffsets.includes(val + this.model.getNumCols())) {
      return true;
    } else {
      return false;
    }
  }

  // To get symbols as a left symbols for cluster win
  private getLeftBound(uniqueOffsets: number[], val: number): boolean {
    if (val % this.model.getNumCols() == 0) {
      return true;
    } else if (!uniqueOffsets.includes(val - 1)) {
      return true;
    } else {
      return false;
    }
  }

  // To get symbols as a right symbols for cluster win
  private getRightBound(uniqueOffsets: number[], val: number): boolean {
    if (val % this.model.getNumCols() == this.model.getNumCols() - 1) {
      return true;
    } else if (!uniqueOffsets.includes(val + 1)) {
      return true;
    } else {
      return false;
    }
  }

  /** Update win line offset */
  private updateWinLineOffSet(winnings: any): any {
    for (let i: number = 0; i < winnings.length; i++) {
      const winOffset: any = winnings[i];
      for (let j: number = 0; j < winOffset.positions.length; j++) {
        winnings[i].positions[j][1] = winnings[i].positions[j][1] + gameConstants.OFFSET_INCREMENT_X5;
      }
    }
    return winnings;
  }

  /**
   * store total reels on which cascade will occur
   */
  private getTotalReelBurstOffsets(): number {
    let totalNumber: number = 0;
    for (let i: number = 0; i < ingenuity.configData.numberOfReel; i++) {
      const cascadeOffsets: number[][][] = this.model.getCascadeOffsets();
      const currentReelBurstOffsets: any = cascadeOffsets[0].filter((item: any) => item[0] === i);
      totalNumber += currentReelBurstOffsets.length ? 1 : 0;
    }
    return totalNumber;
  }

  /**
   * Add to update reel grid with stack
   */
  private updateReelGridWithStack(grid: any): any {
    let stackData: number[][] = gameConstants.MAN_AND_LADY_STACK_DATA;
    stackData.forEach((value: number[]) => {
      let stackId: number = value[0];
      let stackSize: number = value[1];
      let stackReplaceId: number = value[2];
      for (let j: number = 0; j < grid.length; j++) {
        let count: number = 0;
        for (let i: number = grid[j].length - 1; i >= 0; i--) {
          if (grid[j][i] === stackId) {
            count++;
          } else {
            count = 0;
          }
          if (count === stackSize) {
            grid[j][i] = stackReplaceId;
            for (let k = 1; k < value[1]; k++) {
              grid[j][i + k] = gameConstants.TRANSPARENT_SYMBOL_ID;
            }
            count = 0;
          }
        }
        const lastIndex: number = grid[j].length;
        if (grid[j][lastIndex - 1] === stackId) {
          for (let m = grid[j].length - 1; m >= grid[j].length - stackSize; m--) {
            if (grid[j][m] !== stackId) {
              grid[j][m + 1] && (grid[j][m + 1] = stackReplaceId);
              for (let k = 2; k < stackSize; k++) {
                grid[j][m + k] && (grid[j][m + k] = gameConstants.TRANSPARENT_SYMBOL_ID);
              }
              break;
            }
          }
        }
      }
    }, this);
    return grid;
  }

  protected processGameParameters(params: any): void {
    // ParserLeander.js
    this.model.setTotalBet(params.betPerLineDefault * params.betDivisor);
    this.model.setCurrentTotalBet(params.betPerLineDefault * params.betDivisor);
    this.model.setArrayNumChips(params.betPerLine);
    this.model.setMinBet(params.betPerLine[0]);
    this.model.setMaxBet(params.betPerLine[params.betPerLine.length - 1]);
    this.model.setCurrentBetIndex(params.betPerLine.indexOf(this.model.getBetPerLineDefault()));
    this.model.setAutoPlayDefault(params.autoPlayDefault);
    this.model.setAutoPlayList(params.autoPlayList);
    this.model.setBetDivisor(params.betDivisor);
    this.model.setBetPerLine(params.betPerLine);
    this.model.setBetPerLineDefault(params.betPerLineDefault);
    //params.currencyDecimalPlaces && this.model.setCurrencyDecimalPlaces(params.currencyDecimalPlaces);
    this.model.setNoPrizeReelLayout(params.noPrizeReelLayout);
    this.processPaytableData(params.payTable);
    this.processReelsData(params.reels);

    // Parser.js
    this.storeWinLineValues(gameConstants.lineLayout);
    this.model.setLinesPlayed(params.betDivisor);
    this.model.setCurrentBet(this.model.getBetPerLineDefault());
    this.model.setCurrentBetIndex(this.model.getBetPerLine().indexOf(this.model.getCurrentBet()));
    this.model.setReelGrid(this.updateReelGrid(this.model.getNoPrizeReelLayout()));
    if (params.collectMeter !== undefined) {
      this.parseCollectMeterData(params);
    }
    if (params && params.responseHistory) {
      this.checkAndStoreBrokenData(params.responseHistory);
    }
    this.model.setCurrentBetIndex(this.model.getBetPerLine().indexOf(this.model.getCurrentBet()));
    if (!ingenuity.configData.isBrokenGame) {
      this.convertAndUpdateReelGridWithStack();
    }
    // Process collect meter data on Broken
  }

  protected updateReelGrid(grid: any) {
    const reelGrid = this.changeSymbolNumber(clone(grid));
    let updatedReelGrid = [];
    for (let column = 0; column < this.model.getNumCols(); column++) {
      const innerArray = [];
      for (let row = 0; row < this.model.getNumRows(); row++) {
        const index = column + row * this.model.getNumCols();
        innerArray.push(reelGrid[index]);
      }
      updatedReelGrid.push(innerArray);
    }
    return updatedReelGrid;
  }

  // Overrided to set reels data as per stack implementation
  protected processReelsData(reelsData: any): void {
    this.model.setReelSets(reelsData);
    this.model.setAllReelSet(clone(reelsData));
    this.model.setBaseGameReelSetWithStack(clone(this.changeSymbolNumber(reelsData["Base_100"])));
    this.model.setBaseReel(clone(this.changeSymNumber(clone(this.model.getBaseGameReelSetWithStack()))));
    this.model.setFreeGameReelSetWithStack(clone(this.changeSymbolNumber(reelsData["freeSpin_100"])));
    this.model.setFreeSpinReel(clone(this.changeSymNumber(clone(this.model.getFreeGameReelSetWithStack()))));
  }

  /**
   * function will convert stack symbol id into single symbols id
   */
  private changeSymNumber(grid: number[] | number[][]): any {
    grid.forEach((element: any, index: number) => {
      if (Array.isArray(element)) {
        element.forEach((position: number, index: number) => {
          if (position === gameConstants.MAN_SYMBOL_1X3_ID || position === gameConstants.MAN_SYMBOL_1X5_ID) {
            element[index] = gameConstants.MAN_SYMBOL_ID;
          }
        });
      } else {
        if (element === gameConstants.MAN_SYMBOL_1X3_ID || element === gameConstants.MAN_SYMBOL_1X5_ID) {
          grid[index] = gameConstants.MAN_SYMBOL_ID;
        }
      }
    });
    return grid;
  }

  /**
   * Method overrided to parse feature data.
   * @param response
   */
  protected processBonusInfo(response?: any[]): void {
    this.model.setBonusInfo(response);
    this.resetSpecialSymbolData();
    this.resetMoneyHuntingFeature();
    response.length &&
      response.forEach((data) => {
        if (data.bonusName === ingenuity.configData.FreeSpinSelectReels) {
          this.updateNewBaseReel(data.selectedReels);
        }
        if (data.bonusName === ingenuity.configData.freeSpinsBonusName) {
          this.parseFreeSpin(data);
        }
        if (data.bonusName === ingenuity.configData.TriggerMoneyHuntingFeature) {
          this.parseMoneyHuntingTriggerData(data);
        }
        if (data.bonusName === ingenuity.configData.moneyHunting) {
          this.moneyHuntingFeatureParsing(data);
        }
        if (data.bonusName === ingenuity.configData.cascadeBonusName) {
          this.processCascadeData(data);
        }
        if (data.bonusName === ingenuity.configData.scatterBonusName) {
          this.processTriggerScatterWin(data);
        }
        if (data.bonusName === ingenuity.configData.FreespinRetrigger) {
          this.processRetriggerData(data);
        }
        if (data.bonusName === ingenuity.configData.MysterySymbol) {
          this.parseMysterySymbolData(data);
        }
        if (data.bonusName === ingenuity.configData.SpecialMysterySymbol) {
          this.parseSpecialMysterySymbolData(data);
        }
        if (data.bonusName === ingenuity.configData.CollectMeter) {
          this.parseCollectMeterData(data);
        }
        if (data.bonusName === ingenuity.configData.preCollectMeter) {
          this.parsePreCollectMeterData(data.collectMeter);
        }
        if (data.bonusName === ingenuity.configData.FinalCollectValue) {
          this.parseCollectValue(data);
        }
      });
  }

  private parseMoneyHuntingTriggerData(data: any): void {
    this.model.setMoneyHuntingFetureStatus(data.isMoneyHunting);
    this.model.setStikcyFramesRawData(data.spotlightsquarepos);
    this.model.setStikcyFramesOffsets(this.getGridToOffset(data.spotlightsquarepos));
    if (!this.model.getMoneyHuntingFetureStatus()) return;
    this.model.setSpotlightPosition(this.getPositionToOffset(data.triggerSpotlightOffset));
  }

  /**
     * function will convert line values into offset
     */
  private getPositionToOffset(offset: number) {
    const symOnGrid = offset - 1;
    const row = Math.floor(symOnGrid / this.model.getNumCols());
    const col = symOnGrid % this.model.getNumCols();
    return [col, row];
  }
  private resetMoneyHuntingFeature() {
    this.model.setMoneyRewardSpins(null);
    this.model.setMoneyRewardSpinsCounter(0);
    this.model.setMoneyHuntingTotalWin(0);
    this.model.setPrizeCoinPositions(null);
    this.model.setCollectPosition(null);
    this.model.setMoneyHuntingRewardsDetails(null);
    this.model.setMoneyHuntingFetureStatus(false);
    this.model.setStikcyFramesRawData(null);
    this.model.setStikcyFramesOffsets(this.getGridToOffset(null));
    this.model.setSpotlightPosition(null);
  }

  private moneyHuntingFeatureParsing(data: any): void {
    this.model.setMoneyRewardSpins(data.coinRewardsInfo);
    this.model.setMoneyRewardSpinsCounter(0);
    this.model.setMoneyHuntingTotalWin(data.creditsWon);
    this.parseMoneyHuntingRewardData()
  }
  private parseMoneyHuntingRewardData(): void {
    const data = this.model.getMoneyRewardSpins()[this.model.getMoneyRewardSpinsCounter()];
    const convertedData = this.convertHuntingPositionsWithOffSet(data);
    this.parseCollectDataForHunting(convertedData)
    this.parsePrizeBeforeMultipler(convertedData);
  }
  // to convert positions into offsets
  private convertHuntingPositionsWithOffSet(data: any): any {
    data.forEach((element: any) => {
      element.position = this.getPositionToOffset(element.offSet)
    });
    return data
  }

  private parsePrizeBeforeMultipler(data: any): void {
    data.forEach((element: any) => {
      if (element.reward == "multiplier") {
        let adjacentTiles: any[] = [];
        adjacentTiles = this.getAdjacentPosition(element.position, data);
        element.adjacentTiles = adjacentTiles;
        data.forEach((reward: any) => {
          const exists = adjacentTiles.some((tile: any) =>
            tile.position[0] === reward.position[0] &&
            tile.position[1] === reward.position[1]
          );
          if (exists && reward.reward == 'prize') {
            reward.prize = reward.prize / element.multiplier;
          }
        });
      }
    })
    //sort data with offset
    let rewardData = data.sort((a: any, b: any) => a.offSet - b.offSet);
    // remove duplicate offset
    const seen = new Set();
    const uniqueUsers = rewardData.filter((reward: any) => {
      if (seen.has(reward.offSet)) return false;
      seen.add(reward.offSet);
      return true;
    });

    this.model.setMoneyHuntingRewardsDetails(uniqueUsers);

  }

  private getAdjacentPosition(targetPosition: number[], data: any) {
    const directions = [
      [-1, -1], // up left
      [-1, 0], // up
      [-1, 1], // up right
      [1, -1],  // down left
      [1, 1],  // down right
      [1, 0],  // down
      [0, -1], // left
      [0, 1],  // right
    ];
    const adjacentPositions = directions.map(([dx, dy]) => {
      return [targetPosition[0] + dx, targetPosition[1] + dy];
    });

    // Find objects in data that match those adjacent positions
    const adjacentTiles = data.filter((item: any) => {
      return adjacentPositions.some(pos =>
        item.position[0] === pos[0] && item.position[1] === pos[1]
      );
    });
    const filteredTiles = adjacentTiles.filter((tile: any) => tile.reward !== "collect");
    return filteredTiles;
  }
  private parseCollectDataForHunting(data: any): void {
    const prizePositions: [number, number][] = data.filter((item: any) => (item.reward === "prize" || item.reward === "multiplier" || item.iscollected)).map((item: any) => item.position);
    const collectPositions: [number, number][] = data.filter((item: any) => item.reward === "collect" && !item.iscollected).map((item: any) => item.position);
    this.model.setPrizeCoinPositions(prizePositions);
    this.model.setCollectPosition(collectPositions);
  }
  //update new reel set
  private updateNewBaseReel(reelSetName: string): void {
    let reels: number[][] = clone(this.model.getReelSets(reelSetName));
    if ((ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState) || this.model.getHasFreeGamesWin()) {
      (ingenuity.parserModel as GameParserModel).setFreeSpinReel(this.changeSymbolNumber(reels));
      this.model.setFreeGameReelSetWithStack(clone(this.changeSymbolNumber(reels)));
      dispatcher.fireEvent(eventDispatchers.UDPATE_NEW_FG_REELSET);
    } else {
      this.model.setBaseReel(this.changeSymbolNumber(reels));
      this.model.setBaseGameReelSetWithStack(this.changeSymbolNumber(reels));
      dispatcher.fireEvent(SlotEventConstantsBehavior.UPDATE_REEL_SET);
    }
  }

  private processCascadeData(data: any): void {
    const firstCascadeData: IObject = data.cascadeList[0];
    this.processWinningLines(firstCascadeData.winningLines);
    this.model.setCascadingStatus(true);
    this.model.setCascadeTotalWin(data.creditsWon);
    this.model.setCascadeResponse(data.cascadeList);
    this.model.setCascadingCount(data.cascadeList.length - 1);

    this.processCascadeBonusData(firstCascadeData.bonusInfo); // to parse per cascade bonus infor data.
  }

  private processCascadeBonusData(data: IObject): void {
    data.forEach((bonusData: IObject) => {
      if (bonusData.bonusName === ingenuity.configData.SpecialMysterySymbol) {
        this.parseSpecialMysterySymbolData(bonusData);
      }
    }, this);
  }

  //TODO: this model will be used during cashout feature.
  private parseCollectValue(data: IObject): void {
    // this.model.setFinalCollectValue(data.collectValue);
  }

  private parseMysterySymbolData(data: IObject): void {
    this.mysterySymbol = data.symbolId;
    // this.model.setMysterySymbol(data.symbolId)
  }

  private resetSpecialSymbolData(): void {
    this.model.setIsSpecialSymbol(false);
  }

  /**
   * Method to parse special mystery symbol data
   * @param data
   */
  private parseSpecialMysterySymbolData(data: IObject): void {
    this.model.setSpecialMysterySymbolsData(data.mystery78Info);
  }
  private parseCollectMeterData(data: any): void {
    this.model.setCollectMeterParseData(data.collectMeter);
    data.collectMeter.meterData && this.model.setCollectMeterData(data.collectMeter.meterData);
    (!data.pickedClue && data.collectMeter.meterLimit) && this.model.setCollectLimitData(data.collectMeter.meterLimit);
    data.collectMeter.clueInfo && this.model.setclueInfo(data.collectMeter.clueInfo);
    data.isGrand && this.model.setIsGrandJPAvailable(true);
    data.totalGrandPrize && this.model.setIsGrandJPPrize(data.totalGrandPrize);
    this.parseInvestigationFeatureData(data);
    this.model.setCurrentClueLevel(data.currentLevel);
    //  this.parseInvestigationFeatureData(data);

  }

  private parseInvestigationFeatureData(data: any) {
    let clueRevealedInfo = { pickedClue: '', selectedClue: '', creditsWon: 0, grandPrize: 0 }
    if (data.pickedClue) {
      clueRevealedInfo.pickedClue = data.pickedClue;
      clueRevealedInfo.selectedClue = data.selectedClue;
      clueRevealedInfo.creditsWon = data.creditsWon;
      clueRevealedInfo.grandPrize = data?.updatedData?.grandPrize;
      this.model.setclueRevealedInfo(clueRevealedInfo)
      this.model.setclueRevealedWinAmt(clueRevealedInfo.creditsWon)
      this.model.setClueRevealedFeatureStatus(true);
      this.model.setCollectMeterData(data?.updatedData?.meterData);
      data?.updatedData?.clueInfo && this.model.setTotalClueCount(data?.updatedData?.clueInfo.symbol51.length + data?.updatedData?.clueInfo.symbol52.length + data?.updatedData?.clueInfo.symbol53.length);
      // data.collectMeter.clueInfo[clueRevealedInfo.pickedClue] = data.collectMeter.clueInfo[clueRevealedInfo.pickedClue].filter((value: any) => value !== data.selectedClue);
      if (data.updatedData) {
        data?.updatedData?.clueInfo && this.model.setclueInfo(data?.updatedData?.clueInfo);
        data.updatedData.clueInfo[clueRevealedInfo.pickedClue] = data?.updatedData.clueInfo[clueRevealedInfo.pickedClue].filter((value: any) => value !== data.selectedClue);
      }
    }
  }
  private parsePreCollectMeterData(data: IObject): void {
    data.meterData && this.model.setPreCollectMeterData(data.meterData);
    data.meterLimit && this.model.setPreCollectMeterLimitData(data.meterLimit);
  }


  protected changeSymbolNumber(grid: number[] | number[][]): any[] {
    grid.forEach((element, index) => {
      if (Array.isArray(element)) {
        element.forEach((position, index) => {
          if (this.specialSymNum.includes(position)) {
            element[index] = this.udpatedSpecialSymNum[this.specialSymNum.indexOf(position)];
          } else if (gameConstants.MYSTERY_SYMBOL_ID === position) {
            element[index] = gameConstants.MYSTERY_SYMBOL_GAME_ID;
          } else if (gameConstants.SPECIAL_MYSTERY_SYMBOL_ID === position) {
            element[index] = gameConstants.SPECIAL_MYSTERY_SYMBOL_GAME_ID;
          }
        });
      } else {
        if (this.specialSymNum.includes(element)) {
          grid[index] = this.udpatedSpecialSymNum[this.specialSymNum.indexOf(element)];
        } else if (this.mysterySymols.includes(element)) {
          if (gameConstants.SPECIAL_MYSTERY_SYMBOL_ID === element) {
            this.model.getSpecialMysterySymbolsData().forEach((data: IObject) => {
              grid[data.offset - 1] = this.updateSpecialSymbol(data.symbol);
            }, this);
          } else {
            grid[index] = this.mysterySymbol;
          }
        }
      }
    });
    return grid;
  }

  /**
   * Method to process 78 special mystery symbol.
   * @param symbolNumber
   * @returns
   */
  private updateSpecialSymbol(symbolNumber: number): number {
    if (gameConstants.SPECIAL_SYMBOL_NOTE === symbolNumber) return gameConstants.SPECIAL_SYMBOL_NOTE_ID;
    if (gameConstants.SPECIAL_SYMBOL_MAGNIFY === symbolNumber) return gameConstants.SPECIAL_SYMBOL_MAGNIFY_ID;
    if (gameConstants.SPECIAL_SYMBOL_KEY === symbolNumber) return gameConstants.SPECIAL_SYMBOL_KEY_ID;
    if (gameConstants.SPECIAL_SYMBOL_SPOTLIGHT === symbolNumber) return gameConstants.SPECIAL_SYMBOL_SPOTLIGHT_ID;
  }

  // Overrided to convert grid with stack
  protected parseNextFreeSpinData(evt?: IEvent): void {
    this.resetFeatureData();
    // let featureWinAmount: number = 0;
    const freeSpinData = this.model.getFreeGameResponse()[this.model.getCurrentFreeSpinCount()][0];
    this.parseCascadeGridInFreeGame(freeSpinData);
    const response = this.model.getFreeGameResponse();
    const data = response[this.model.getCurrentFreeSpinCount()][0];
    this.model.getTriggerWinLinesData().length = 0;
    this.model.getTriggerScatterWinData().length = 0;
    this.model.getFreeSpinsRemaining() ? this.model.setFreeSpinsRemaining(this.model.getFreeSpinsRemaining() - 1) : this.model.setFreeSpinsRemaining(0);
    data.spinsRetrigger && this.model.setRetriggerFreeSpins(data.spinsRetrigger);
    this.model.setCurrentlyProcessingFSAmt(this.model.getFreeSpinWinAmt() + this.model.getTotalCascadeWin() + this.model.getMoneyAndClueBasegameWin());
    this.model.setFreeSpinWinAmt(this.model.getFreeSpinWinAmt() + data.creditsWon);
    this.model.setCurrentWin(data.creditsWon);
    data.creditsWon > 0 ? this.model.setHasWin(true) : this.model.setHasWin(false);
    this.model.setReelGrid(this.updateReelGrid(data.reelLayout));
    this.processLinesData(data.winningLines.lines);
    this.model.getWinLinesData().length > 0 ? this.model.setHasLineWins(true) : this.model.setHasLineWins(false);
    this.model.getTriggerScatterWinData().length > 0 && this.model.setHasScatterWins(true);
    this.model.setCurrentFreeSpinCount(this.model.getCurrentFreeSpinCount() + 1);
    this.processBonusInfo(data.bonusInfo); // to check reetrigger
    dispatcher.fireEvent(PlatformEventConstants.SPIN_RESPONSE_PROCESSED);
    this.checForStackSyminReelGridFG();

    this.model.setFreeGameStops(freeSpinData.reelStops);
    this.model.setReelGrid(
      this.convertReelGridWithStops(this.model.getReelGrid(), this.model.getFreeGameStops(), this.model.getFreeGameReelSetWithStack())
    );
    this.model.setReelGrid(this.updateMysterySymbolsInGrid(this.model.getReelGrid()));
    this.model.setReelGrid(this.updateReelGridWithStack(this.model.getReelGrid()));
    this.parseCollectSymbolOffestsData();
  }

  protected processBrokenGameData(data: any): void {
    super.processBrokenGameData(data);
    data.stickyFramesFG && this.model.setStickyFramesPosition(data.stickyFramesFG);
  }

  // Overrided to parse free game response in case of broken
  protected parseBrokenFreeGameData(): void {
    // let featureWinAmount: number;
    this.resetFeatureData();
    const freeSpinData = this.model.getFreeGameResponse()[this.model.getCurrentFreeSpinCount()][0];
    this.parseCascadeGridInFreeGame(freeSpinData);
    super.parseBrokenFreeGameData();
    this.model.setFreeGameStops(freeSpinData.reelStops);
    this.model.setReelGrid(
      this.convertReelGridWithStops(this.model.getReelGrid(), this.model.getFreeGameStops(), this.model.getFreeGameReelSetWithStack())
    );
    this.model.setCurrentWin(this.model.getCurrentWin());
    this.model.setCurrentlyProcessingFSAmt(freeSpinData.creditsWonAccumulated + this.model.getTotalCascadeWin()+ this.model.getMoneyAndClueBasegameWin());

    this.model.setReelGrid(this.updateMysterySymbolsInGrid(this.model.getReelGrid()));
    this.model.setReelGrid(this.updateReelGridWithStack(this.model.getReelGrid()));
    this.parseCollectSymbolOffestsData();
    if (ingenuity.configData.isBrokenGame) {
      this.model.setTriggerReelGrid(this.model.getLastCascadeGridForFg());
    }
  }

  /**
   * function will change first cascade grid with actual response reel grid
   */
  private parseCascadeGridInFreeGame(response: any): void {
    this.resetFgCascadeData(); // reset cascade data
    // new logic for cascade game
    const bonusData = response.bonusInfo.find((data: IObject) => data.bonusName === ingenuity.configData.cascadeBonusName);
    if (bonusData?.cascadeList?.length) {
      const cascade = bonusData.cascadeList[0];
      this.processCascadeBonusData(cascade.bonusInfo); // to parse fist cascade bonus info data.
      response.reelLayout = cascade.cascadeGrid;
      response.winningLines = cascade.winningLines;
      response.reelStops = cascade.stops;
      this.model.setTotalFgCascadeWin(bonusData.creditsWon);
      this.model.setCascadeAccumulatedWin(bonusData.cascadeList[0].winningLines.creditsWon);
    }
  }

  /**
   * This method will reset fg cascade data.
   */
  private resetFgCascadeData(): void {
    this.model.setCascadingStatus(false);
    this.model.setTotalFgCascadeWin(0);
    this.model.setCascadeAccumulatedWin(0);
  }
  // TODO: Shift code to behavior 
  protected processGetBetResult(betResultData: any) {
    (betResultData.balance >= 0) && this.model.setBalance(betResultData.balance);
    betResultData.freeBalance && this.model.setFreeBalance(betResultData.freeBalance);
    this.model.setFreePlaysData(betResultData.freePlaysData);
    betResultData.params && this.processParameters(betResultData.params[0]);
    this.model.setIsPlayingFreePlay(betResultData.playingFreePlay);
    dispatcher.fireEvent(EventConstants.UPDATE_CREDIT_VALUE);
  }
  protected processGameAfterError(): void {
    // super.processGameAfterError();
    this.model.setNoSettleOnError(true);
    this.model.setReelGrid(this.updateReelGrid(this.model.getNoPrizeReelLayout()));
    this.convertAndUpdateReelGridWithStack()
    dispatcher.fireEvent(EventConstants.SPIN_RESPONSE_PROCESSED);
  }

  /**
   * function will parse the last cascasde grid to handle the basegame returining grid in case of freegame broken
   */
  private getTriggeringGrid(data: any): number[][] {
    let grid: number[]
    let lastMoneySpinResponse: any
    data.bonusInfo.forEach((info: any) => {
      if (info.bonusName === ingenuity.configData.cascadeBonusName) {
        if (info?.cascadeList?.length) {
          grid = info.cascadeList[info.cascadeList.length - 1]?.cascadeGrid
        }
      }
      if (info.bonusName === ingenuity.configData.moneyHunting) {
        if (info.coinRewardsInfo) {
          lastMoneySpinResponse = info.coinRewardsInfo[info.coinRewardsInfo.length - 1]
        }
      }
    })
    if(lastMoneySpinResponse?.length){
      let updateGridWithMoneyHunting = this.getMoneyHuntingGrid(lastMoneySpinResponse, grid)
      grid = updateGridWithMoneyHunting;
    }
    let updatesGrid
    if (grid?.length) {
      updatesGrid = this.updateReelGrid(grid)
      updatesGrid = this.updateReelGridWithStack(this.convertReelGridWithStops(updatesGrid, this.model.getBaseGameStops(), this.model.getBaseReel()))
    }
    return updatesGrid?.length > 0 ? updatesGrid : [];

  }
  private getMoneyHuntingGrid(lastMoneySpinResponse: any, reelGrid: number[]): number[] {
    let grid: number[] = clone(reelGrid);
    for (let j = 0; j < lastMoneySpinResponse.length; j++) {
      grid[lastMoneySpinResponse[j].offSet - 1] = this.getSymbolIDByColor(lastMoneySpinResponse[j])
    };
    return grid
  }
  private getSymbolIDByColor(data: any): number {
    let coinType: number;
    if (data.reward == 'multiplier') {
      coinType = 29;
    }  else if(data.reward == 'prize') {
      if (data.prize < 0.5) {
        coinType = 25;
      } else if (data.prize >= 0.5 && data.prize < 1) {
        coinType = 26;
      } else if (data.prize >= 1) {
        coinType = 27;
      }
    }else if (data.reward == 'collect') {
      coinType = 28;
    }
    return coinType;
  }
}
